var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Card, Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';
import { T } from '../../../helpers/i18n';
import { TypeCommission } from '../../Afiliates/Model';
import { Button } from '../../../elements';
import Theme from '../../../Theme';
import { useApplyCommission } from '../../../hooks/useApplyCommission';
import { inject } from 'mobx-react';
var CommmissionCollaborator = function (props) {
    var collaborator = props.collaborator, store = props.store;
    var applyCommission = useApplyCommission(store);
    if (!collaborator) {
        return null;
    }
    return (React.createElement(Card, { className: "m-3 p-3" },
        React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, { xl: 2, md: 6, sm: 12 },
                    React.createElement(FormGroup, null,
                        React.createElement(Label, { for: "commissionCollaborator" }, T('commission')),
                        React.createElement(Input, { value: collaborator.comission ? (collaborator.comission + (collaborator.typeCommission === TypeCommission.Percentage ? '%' : '')) : '------------', id: "commissionCollaborator", disabled: true }))),
                collaborator.comission && (React.createElement(Col, { xl: 6, md: 6, sm: 12 },
                    React.createElement("div", { style: {
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center'
                        } },
                        React.createElement(Button, { style: __assign({}, Theme.border), onClick: function () { return applyCommission(collaborator); }, disabled: !collaborator.comission }, T('applyNet')))))))));
};
export default inject('store')(CommmissionCollaborator);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Collaborators/container/CommissionCollaborator.tsx
// module id = 596
// module chunks = 0